import React from 'react';
import PropTypes from 'prop-types';
const occupationArr = [
  '農牧業',
  '漁業',
  '木材森林業',
  '礦業採石業',
  '交通運輸業',
  '餐旅業',
  '建築工程業',
  '製造業',
  '新聞廣告娛樂業',
  '衛生保健業',
  '文教機關',
  '公家機關',
  '一般商業',
  '其他',
];

const RegisterOccupation = (props) => {
  const { occupation } = props;

  return (
    <div className="field is-horizontal">
      <div className="field-label is-medium">
        <label className="label">購買人職業</label>
      </div>
      <div className="field-body">
        <div className="field">
          <div className="control">
            <div className="select">
              <select
                className="age"
                value={occupation}
                onChange={(e) => {
                  props.handleChange(e.target.value, 'occupation');
                }}
              >
                {occupationArr.map(elem => (
                  <option key={`occupation-${elem}`} value={elem}>
                    {elem}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RegisterOccupation.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default RegisterOccupation;



// WEBPACK FOOTER //
// ./src/components/RegisterOccupation.js